import { useDispatch } from 'react-redux';
import { showLoading, hideLoading } from '../redux/slices/loadingSlice';

const useLoading = () => {
  const dispatch = useDispatch();

  return {
    showLoading: (message) => dispatch(showLoading(message)),
    hideLoading: () => dispatch(hideLoading())
  };
};

export default useLoading;